import React,{Component} from 'react';
import classNames from 'classnames';
import Dummy from '../Dummy';
import styles from './style.css';

export default class Menu extends Dummy {
    constructor() {
        super();
        this.renderItems = :: this.renderItems;
    }

    renderItems () {
        return this.props.menuItems.map( (item, index)=>{
            let itemClass = {};
            itemClass[styles.active] = (this.props.activeScreen == item[0]);
            if (item[2] !== null && item[2]!==undefined && !itemClass[styles.active]) {
                itemClass[styles.avar] = (this.getCleanValue(this.props.ps[item[2]]) == 1);
            }
            return (
                <a className={classNames("col-md-2", itemClass)}
                   id={item[0] + 'Menu'}
                   onClick={() => {this.props.setActiveScreen(item[0])}}
                   key={index} >{item[1]}
                </a>)
        });
    }

    render() {
        const items = this.renderItems();

        return (
            <div className={classNames('row',styles.myMenu)}>
                {items}
            </div>
        )}
};



// WEBPACK FOOTER //
// ./src/lib/core/Menu/index.jsx